export enum MarketingChannel {
	Email = 'Email',
	AppNotifications = 'AppNotifications',
	SMS = 'SMS',
	PartnerOffers = 'PartnerOffers',
	Phone = 'Phone',
}
